export const excludeNullAndUndefined = (obj: Record<string, string | null | undefined>) => {
  const res: Record<string, string> = {}
  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value !== 'undefined' && value !== null) {
      res[key] = value
    }
  })
  return res
}
